
{
  "nav": {
    "home": "Home",
    "explore": "Explore",
    "about": "About",
    "pricing": "Pricing",
    "submitListing": "Submit Listing",
    "login": "Login",
    "signup": "Sign Up"
  },
  "userMenu": {
    "profile": "Profile",
    "myListings": "My Listings",
    "favorites": "Favorites",
    "referFriend": "Refer a Friend",
    "paymentPending": "Payment Pending",
    "logout": "Logout",
    "upgradeToPremium": "Upgrade subscription",
    "updateListing": "Update Your Listing",
    "addListing": "Add Listing"
  },
  "navigation": {
    "home": "Home",
    "explore": "Explore",
    "about": "About",
    "pricing": "Pricing",
    "login": "Login",
    "signup": "Sign Up",
    "admin": "Admin"
  },
  "buttons": {
    "loading": "Loading..."
  },
  "profile": {
    "title": "Account workspace",
    "description": "Manage your profile, security, and provider subscription",
    "completeTitle": "Complete Your Profile",
    "completeDescription": "Please complete your profile to continue",
    "profileNotFound": "Profile not found",
    "tabs": {
      "profile": "Profile",
      "security": "Security"
    },
    "loading": "Loading profile...",
    "completeAlert": "Please complete your profile information to continue using your WhatsGood HK workspace.",
    "form": {
      "title": "Profile Information",
      "description": "Keep your account and provider contact details current",
      "completeTitle": "Complete Your Profile",
      "completeDescription": "Please fill in your profile information to get started",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "whatsappNumber": "WhatsApp Number",
      "phoneNumber": "Phone Number",
      "required": "*",
      "whatsappPlaceholder": "e.g., +852 1234 5678",
      "phonePlaceholder": "e.g., +852 1234 5678",
      "whatsappDescription": "Your WhatsApp number for customer contact",
      "phoneDescription": "Alternative phone number (optional)",
      "whatsappVerified": "Verified",
      "saving": "Saving...",
      "save": "Save Changes",
      "complete": "Complete Profile"
    },
    "security": {
      "title": "Security Settings",
      "description": "Update your password and security preferences",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "passwordPlaceholder": "Enter your password",
      "passwordRequirement": "Password must be at least 8 characters long",
      "updating": "Updating...",
      "update": "Update Password",
      "error": "Error",
      "success": "Password updated successfully"
    }
  },
  "listings": {
    "title": "My Listings",
    "description": "Manage the service listings included in your subscription",
    "loading": "Loading listings...",
    "addNewListing": "Add New Listing",
    "empty": {
      "noListings": "No listings found",
      "noListingsDescription": "Create your first listing to start building your provider presence on WhatsGood HK.",
      "noFilteredListings": "No listings found for the selected status",
      "addListingButton": "Create Listing",
      "viewAllButton": "View All Listings"
    },
    "filters": {
      "all": "All Status",
      "pending": "Pending",
      "approved": "Active",
      "rejected": "Rejected"
    },
    "alerts": {
      "freeTierTitle": "Starter plan limit",
      "freeTierDescription": "Your current plan includes one active listing. ",
      "additionalListingsRejected": "Additional listings may be rejected until you upgrade. ",
      "upgradePrompt": "Upgrade to Premium to unlock unlimited listings.",
      "upgradeButton": "Upgrade subscription"
    }
  },
  "favorites": {
    "title": "My Favorites",
    "description": "Service providers you've saved",
    "loading": "Loading favorites...",
    "searchPlaceholder": "Search your favorites...",
    "providerCount": "Showing {{count}} {{provider}}",
    "provider_one": "provider",
    "provider_other": "providers",
    "noFavorites": {
      "title": "No favorites yet",
      "description": "Save service providers you're interested in to see them here",
      "button": "Browse Services"
    },
    "noSearchResults": {
      "title": "No search results",
      "description": "Try adjusting your search terms or clear the search to see all favorites",
      "button": "Clear Search"
    }
  },
  "contact": {
    "providerWhatsappInquiryMessage": "Hello, I found {{serviceName}} on WhatsGood HK and would like to enquire."
  },
  "footer": {
    "description": "Find reputable Hong Kong service providers faster, with a directory built for expats who want clarity and direct contact.",
    "quickLinks": "Quick Links",
    "legal": "Legal",
    "contact": "Contact",
    "followUs": "Follow Us",
    "copyright": "© 2025 WhatsGood HK.",
    "about": "About",
    "aboutDescription": "A Hong Kong service directory built to help expats find reputable providers faster",
    "home": "Home",
    "browseServices": "Browse Services",
    "listYourService": "List Your Service",
    "aboutUs": "About Us",
    "pricing": "Pricing",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "getInTouch": "Get in Touch",
    "getInTouchDescription": "Questions about finding a provider or listing your business? We're here to help.",
    "contactUs": "Contact Us",
    "loadingContact": "Loading contact...",
    "whatsappUs": "WhatsApp Us",
    "whatsappInquiryMessage": "Hello, I would like to enquire about WhatsGood HK.",
    "shareViaWhatsapp": "Share via WhatsApp"
  }
}
